import { useCallback, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import useGlobals from './useGlobals';
import { creditService } from '../Services/creditService';
import { AddCreditData } from '../Types/ServiceTypes';

const useAddCredit = () => {
    const { handleNavigate, userSettings, i18n, demo } = useGlobals();
    const [creditTitle, setCreditTitle] = useState<string>('');
    const [creditAmount, setCreditAmount] = useState<number>(0);

    const handleCreditTitleChange = useCallback((value: string) => {
        setCreditTitle(value);
    }, []);

    const handleCreditAmountChange = useCallback((value: number) => {
        setCreditAmount(value);
    }, []);

    const notifySuccess = useCallback(() => {
        toast.success(i18n.translate({ id: 'credit.stored', sourceName: 'AddCredit' }));
    }, [i18n]);

    const getCreditTitle = useCallback(
        (): string =>
            creditTitle !== '' ? creditTitle : i18n.translate({ id: 'credit.prepaid', sourceName: 'AddCredit' }),
        [creditTitle, i18n],
    );

    const handleSave = useCallback(() => {
        if (demo) {
            notifySuccess();
            return;
        }

        if (!userSettings.isLoggedIn) return;

        const creditData: AddCreditData = {
            title: getCreditTitle(),
            amount: creditAmount.toString(),
        };

        creditService.addCredit(creditData).then(() => {
            handleNavigate('/admin/billing');
            notifySuccess();
        });
    }, [creditAmount, demo, handleNavigate, userSettings, notifySuccess, getCreditTitle]);

    const TemplateActions = useMemo(
        () => ({
            handleSave,
            handleCreditTitleChange,
            handleCreditAmountChange,
        }),
        [handleSave, handleCreditAmountChange, handleCreditTitleChange],
    );

    return {
        TemplateActions,
        creditTitle,
        creditAmount,
        userSettings,
        demo,
        i18n,
    };
};

export default useAddCredit;
